import { initialState } from "./state";

export const worksheets = (state = initialState, action) => {
  switch (action.type) {
    case "SET_WORKSHEET_LIST": {
      return {
        ...state,
        worksheets: action.data,
      };
    }

    default:
      return state;
  }
};
